import { z } from 'zod'

export const legalRolandSchema = z.object({
  employment_status: z.enum([
    'permanently_employed',
    'civil_servant',
    'student',
    'apprentice',
    'self_employed',
    'retired',
    'other',
  ]),

  insured_parties: z.enum(['myself', 'my_family', 'me_and_my_partner', 'me_and_my_children']),

  previous_insurance_got_canceled: z.boolean(),
})
